export default {
  methods: {
    getBasicConfirmMsgBox(action) {
      if (action !== 'Delete') {
        console.error(`getBasicConfirmMsgBox: action [${action}] is not supported`);
      }

      return {
        title: this.$t("Webportal.PleaseConfirm"),
        size: 'md',
        buttonSize: 'md',
        okVariant: 'danger',
        okTitle: this.$t("Webportal." + action),
        cancelTitle: this.$t("Webportal.Cancel"),
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      };
    },
  }
};
